import { ChangeEvent, Suspense, useMemo, useRef, useState } from 'react';
import { Button, ListItem, ListItemText, Stack, TextField, TextFieldProps } from '@mui/material';
import { VariableSizeList } from 'react-window';
import { IServerPack } from '../../../../@types/server';
import MenuPopover from 'components/menu-popover/MenuPopover';

interface IPackProviderPopoverProps extends Omit<TextFieldProps, 'variant'> {
  text: string;
  onChangePack: (data: IServerPack) => void;
  onChangeText: (text: string) => void;
  packs: IServerPack[];
}

export default function PackProviderPopover({
  text,
  onChangePack,
  onChangeText,
  packs,
  className,
  ...other
}: IPackProviderPopoverProps) {
  const cusRef = useRef<HTMLInputElement | null>(null);
  const searchRef = useRef<HTMLInputElement | null>(null);
  const [search, setSearch] = useState<string>('');
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchor(event.currentTarget);
    searchRef.current?.focus();
  };

  const handleClose = () => {
    setSearch('');
    setAnchor(null);
  };

  const datas = useMemo(
    () =>
      packs.filter(
        (f) =>
          f.id.includes((search ?? '').toLocaleLowerCase()) ||
          f.displayName.toLocaleLowerCase().includes((search ?? '').toLocaleLowerCase())
      ),
    [packs, search]
  );

  const getItemSize = () => {
    return 50; // Thay đổi giá trị này theo chiều cao của mỗi phần tử trong danh sách
  };

  const handleSelectItem = (data: IServerPack) => {
    handleClose();
    onChangePack(data);
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    onChangeText(e.target.value);
  };

  return (
    <>
      <TextField
        ref={cusRef}
        {...other}
        className={className}
        fullWidth
        label="type"
        size="small"
        value={text}
        onChange={handleChange}
        onClick={handleOpen}
      />
      <MenuPopover
        open={anchor}
        anchorEl={anchor}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        onClose={handleClose}
        sx={{
          width: { xs: '100%', sm: 500, md: 800 },
          '& .MuiMenuItem-root': {
            typography: 'body2',
            borderRadius: 0.75,
          },
        }}
        className={className}
      >
        <Stack spacing={2}>
          <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1}>
            <Button size="small" color="error" variant="contained" onClick={handleClose}>
              Đóng
            </Button>
            <TextField
              ref={searchRef}
              label="Tìm kiếm thông tin máy chủ"
              size="small"
              fullWidth
              autoFocus
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </Stack>
          <Suspense fallback={<div>Đang tải...</div>}>
            <VariableSizeList
              height={500} // Đặt chiều cao của danh sách
              itemCount={datas.length} // Số lượng mục trong danh sách
              itemSize={getItemSize} // Hàm tính toán kích thước của từng mục
              width="100%" // Đặt chiều rộng của danh sách
            >
              {({ index, style }) => (
                <ListItem key={index} style={style} onClick={() => handleSelectItem(datas[index])}>
                  <ListItemText
                    primary={`${datas[index].id} - ${datas[index].displayName} (${datas[index].price})`}
                    secondary={`${datas[index].groupName}`}
                  />
                </ListItem>
              )}
            </VariableSizeList>
          </Suspense>
        </Stack>
      </MenuPopover>
    </>
  );
}
